(function() {
  'use strict';
  
  // 只处理手动加粗的数字（strong、b标签内的数字），支持p、ul、li标签
  function processManualBoldNumbers() {
    const richTextElements = document.querySelectorAll('.t4s-hero-image .t4s-rich-text-process-number');
    
    richTextElements.forEach(function(element) {
      // 在p、ul、li标签内查找 strong 和 b 标签内的数字
      const containers = element.querySelectorAll('p, ul, li');
      
      containers.forEach(function(container) {
        const boldElements = container.querySelectorAll('strong, b, [style*="font-weight: bold"], [style*="font-weight:900"], [style*="font-weight: 900"]');
        
        boldElements.forEach(function(boldEl) {
          // 如果元素内只有数字，添加 t4s-rich-text-number 类以应用样式
          const text = boldEl.textContent.trim();
          if (/^\d+(?:\.\d+)?%?$/.test(text)) {
            boldEl.classList.add('t4s-rich-text-number');
          } else {
            // 如果元素内包含数字和其他文本，只对数字部分进行处理
            const walker = document.createTreeWalker(
              boldEl,
              NodeFilter.SHOW_TEXT,
              null
            );
            
            const textNodes = [];
            let textNode;
            while (textNode = walker.nextNode()) {
              textNodes.push(textNode);
            }
            
            textNodes.forEach(function(textNode) {
              const text = textNode.textContent;
              const numberRegex = /(\d+(?:\.\d+)?%?)/g;
              const matches = [];
              let match;
              
              while ((match = numberRegex.exec(text)) !== null) {
                matches.push({
                  text: match[0],
                  index: match.index,
                  length: match[0].length
                });
              }
              
              if (matches.length === 0) return;
              
              const fragment = document.createDocumentFragment();
              let lastIndex = 0;
              
              matches.forEach(function(match) {
                if (match.index > lastIndex) {
                  fragment.appendChild(document.createTextNode(text.substring(lastIndex, match.index)));
                }
                
                const span = document.createElement('span');
                span.className = 't4s-rich-text-number';
                span.textContent = match.text;
                fragment.appendChild(span);
                
                lastIndex = match.index + match.length;
              });
              
              if (lastIndex < text.length) {
                fragment.appendChild(document.createTextNode(text.substring(lastIndex)));
              }
              
              textNode.parentNode.replaceChild(fragment, textNode);
            });
          }
        });
      });
    });
  }
  
  // 图片顺序功能
  function applyImageOrder() {
    if (window.innerWidth <= 767) {
      document.querySelectorAll('.t4s-hero-image .t4s-img-positioned[data-order-mb]').forEach(function(el) {
        var order = parseInt(el.getAttribute('data-order-mb'));
        if (order > 0) {
          el.style.order = order;
        } else {
          el.style.order = '';
        }
      });
    } else {
      document.querySelectorAll('.t4s-hero-image .t4s-img-positioned[data-order-mb]').forEach(function(el) {
        el.style.order = '';
      });
    }
  }
  
  // 处理移动端背景图片（CSS已通过媒体查询处理，这里只作为后备和确保样式正确）
  function applyMobileBackgroundImage() {
    // CSS媒体查询已经处理了移动端图片，这里只需要确保样式属性正确
    // 主要用于处理窗口大小改变时的动态调整
    document.querySelectorAll('.t4s-hero-block[data-image-mb-url]').forEach(function(el) {
      if (window.innerWidth <= 767) {
        // 移动端：确保背景图片相关样式正确（CSS已设置，这里只确保）
        el.style.backgroundSize = 'cover';
        el.style.backgroundRepeat = 'no-repeat';
        el.style.backgroundAttachment = 'scroll';
      } else {
        // 桌面端：清除内联样式，让CSS变量生效
        el.style.backgroundImage = '';
        el.style.backgroundSize = '';
        el.style.backgroundRepeat = '';
        el.style.backgroundAttachment = '';
        el.style.backgroundPosition = '';
      }
    });
  }
  
  // Show More 功能
  function initShowMore() {
    const showMoreWrappers = document.querySelectorAll('.t4s-hero-image .t4s-show-more-wrapper');
    if (showMoreWrappers.length === 0) return;
    
    showMoreWrappers.forEach(function(showMoreWrapper) {
      const btn = showMoreWrapper.querySelector('.t4s-show-more-btn');
      const labelEl = btn ? btn.querySelector('.t4s-show-more-text') : null;
      const collapsedLabel = labelEl ? labelEl.textContent.trim() : 'SHOW MORE';
      const expandedLabel = 'HIDE';
      const collapseHeight = showMoreWrapper.getAttribute('data-collapse-height') || '200';
      const expandedHeight = showMoreWrapper.getAttribute('data-expanded-height');
      const originalHeight = showMoreWrapper.getAttribute('data-original-height');
      const expandedTopOffsetMb = parseInt(showMoreWrapper.getAttribute('data-expanded-top-offset-mb') || '0');
      const sectionId = showMoreWrapper.getAttribute('data-section-id');
      
      // 查找包含 t4s-has-show-more 类的 content-wrapper
      const contentLayout = showMoreWrapper.previousElementSibling;
      if (!contentLayout || !contentLayout.classList.contains('t4s-hero-content-layout')) return;
      
      // 检查是否存在 Image(Child) - 通过检查 contentLayout 是否有 t4s-has-image-child 类
      const hasImageChild = contentLayout.classList.contains('t4s-has-image-child');
      
      // 如果存在左右两侧 wrapper，将 show more wrapper 移动到 t4s-hero-content-left 里面
      // 如果没有左右列，show more wrapper 保持在原位置（contentLayout 之后）
      if (hasImageChild) {
        const leftCol = contentLayout.querySelector('.t4s-hero-content-left');
        if (leftCol) {
          // 将 show more wrapper 移动到 t4s-hero-content-left 内部（作为它的子元素）
          leftCol.appendChild(showMoreWrapper);
          // 设置 padding-left 为 0
          showMoreWrapper.style.paddingLeft = '0';
        }
      }
      
      // 在移动端，将文本内容中的图片移到 show more 按钮之后（只处理 t4s-img-inline）
      function moveImagesAfterShowMore() {
        if (window.innerWidth > 767) {
          // 桌面端：恢复图片块到原位置
          if (hasImageChild) {
            const leftCol = contentLayout.querySelector('.t4s-hero-content-left');
            if (leftCol) {
              const contentWrapper = leftCol.querySelector('.t4s-hero-content-wrapper');
              if (contentWrapper) {
                const allImageBlocks = leftCol.querySelectorAll('.t4s-img-inline');
                allImageBlocks.forEach(function(imageBlock) {
                  if (imageBlock.parentElement === leftCol) {
                    leftCol.removeChild(imageBlock);
                    contentWrapper.appendChild(imageBlock);
                  }
                });
              }
            }
          } else {
            // 没有左右列的情况：将图片块从父元素移回 content-wrapper
            const contentWrapper = contentLayout.querySelector('.t4s-hero-content-wrapper');
            if (contentWrapper) {
              // 查找 show more wrapper 的父元素（应该是 content-wrap）
              const parentElement = showMoreWrapper.parentElement;
              if (parentElement) {
                const allImageBlocks = parentElement.querySelectorAll('.t4s-img-inline');
                allImageBlocks.forEach(function(imageBlock) {
                  // 如果图片块在父元素中但不在 contentWrapper 中，移回 contentWrapper
                  if (imageBlock.parentElement === parentElement && imageBlock !== showMoreWrapper) {
                    parentElement.removeChild(imageBlock);
                    contentWrapper.appendChild(imageBlock);
                  }
                });
              }
            }
          }
          return;
        }
        
        // 移动端：将图片块移到 show more 按钮之后
        if (hasImageChild) {
          // 有左右列的情况
          const leftCol = contentLayout.querySelector('.t4s-hero-content-left');
          if (!leftCol || showMoreWrapper.parentElement !== leftCol) return;
          
          const contentWrapper = leftCol.querySelector('.t4s-hero-content-wrapper');
          if (!contentWrapper) return;
          
          const allImageBlocks = leftCol.querySelectorAll('.t4s-img-inline');
          allImageBlocks.forEach(function(imageBlock) {
            // 只处理还在 contentWrapper 中的图片块
            if (imageBlock.parentElement === contentWrapper) {
              // 将图片块从 contentWrapper 移到 leftCol，放在 show more 按钮之后
              contentWrapper.removeChild(imageBlock);
              if (showMoreWrapper.nextSibling) {
                leftCol.insertBefore(imageBlock, showMoreWrapper.nextSibling);
              } else {
                leftCol.appendChild(imageBlock);
              }
            }
          });
        } else {
          // 没有左右列的情况：将图片块移到 show more wrapper 之后
          // show more wrapper 保持在 contentLayout 之后（作为兄弟元素）
          const contentWrapper = contentLayout.querySelector('.t4s-hero-content-wrapper');
          if (!contentWrapper) return;
          
          // 获取 show more wrapper 的父元素（应该是 content-wrap）
          const parentElement = showMoreWrapper.parentElement;
          if (!parentElement) return;
          
          const allImageBlocks = contentWrapper.querySelectorAll('.t4s-img-inline');
          allImageBlocks.forEach(function(imageBlock) {
            // 将图片块从 contentWrapper 移到父元素，放在 show more wrapper 之后
            contentWrapper.removeChild(imageBlock);
            if (showMoreWrapper.nextSibling) {
              parentElement.insertBefore(imageBlock, showMoreWrapper.nextSibling);
            } else {
              parentElement.appendChild(imageBlock);
            }
          });
        }
      }
      
      // 等待内容加载完成后执行
      waitForImages(function() {
        moveImagesAfterShowMore();
      });
      
      // 监听窗口大小改变，重新处理图片位置
      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          moveImagesAfterShowMore();
        }, 100);
      });
      
      const contentWrappers = contentLayout.querySelectorAll('.t4s-hero-content-wrapper.t4s-has-show-more');
      if (!btn || contentWrappers.length === 0) return;

      function syncButtonLabel() {
        if (!labelEl) return;
        const isExpanded = showMoreWrapper.classList.contains('t4s-expanded');
        const nextLabel = isExpanded ? expandedLabel : collapsedLabel;
        labelEl.textContent = nextLabel;
        btn.setAttribute('aria-label', nextLabel);
      }
      
      // 查找 section 根元素以修改 CSS 变量
      let sectionElement = null;
      if (sectionId) {
        sectionElement = document.querySelector('.t4s_nt_se_' + sectionId);
      }
      if (!sectionElement) {
        // 如果找不到，向上查找最近的 section-inner
        let parent = showMoreWrapper.parentElement;
        while (parent && !parent.classList.contains('t4s-section-inner')) {
          parent = parent.parentElement;
        }
        sectionElement = parent;
      }
      
      // 设置初始高度到所有 content-wrapper
      contentWrappers.forEach(function(contentWrapper) {
        contentWrapper.style.setProperty('--collapse-height', collapseHeight + 'px');
      });
      syncButtonLabel();
      
      // 等待图片加载完成的辅助函数
      function waitForImages(callback) {
        const images = contentLayout.querySelectorAll('img');
        if (images.length === 0) {
          callback();
          return;
        }
        
        let loadedCount = 0;
        const totalImages = images.length;
        let hasCalledCallback = false;
        
        function imageLoaded() {
          loadedCount++;
          if (loadedCount >= totalImages && !hasCalledCallback) {
            hasCalledCallback = true;
            // 延迟一点时间确保布局已更新
            setTimeout(callback, 100);
          }
        }
        
        images.forEach(function(img) {
          if (img.complete) {
            imageLoaded();
          } else {
            img.addEventListener('load', imageLoaded, { once: true });
            img.addEventListener('error', imageLoaded, { once: true });
          }
        });
        
        // 设置超时，防止某些图片永远不加载
        setTimeout(function() {
          if (!hasCalledCallback) {
            hasCalledCallback = true;
            callback();
          }
        }, 2000);
      }
      
      // 检查内容是否超出高度
      function checkContentHeight() {
        if (window.innerWidth > 767) {
          showMoreWrapper.style.display = 'none';
          return;
        }
        
        // 计算所有 content-wrapper 的总高度
        let totalHeight = 0;
        contentWrappers.forEach(function(contentWrapper) {
          // 如果存在 Image(Child)，只计算左侧 wrapper（包含文本内容）的高度
          if (hasImageChild) {
            const parentCol = contentWrapper.closest('.t4s-hero-content-col');
            if (parentCol && parentCol.classList.contains('t4s-hero-content-left')) {
              // 计算左侧 wrapper 的内容高度
              const height = Math.max(contentWrapper.scrollHeight, contentWrapper.offsetHeight);
              totalHeight += height;
            }
          } else {
            // 没有 Image(Child) 时，计算所有 wrapper 的高度
            const height = Math.max(contentWrapper.scrollHeight, contentWrapper.offsetHeight);
            totalHeight += height;
          }
        });
        
        const maxHeight = parseInt(collapseHeight);
        
        if (totalHeight <= maxHeight) {
          showMoreWrapper.style.display = 'none';
        } else {
          showMoreWrapper.style.display = 'flex';
        }
      }
      
      // 使用防抖函数优化性能
      let checkTimeout;
      function debouncedCheckContentHeight() {
        clearTimeout(checkTimeout);
        checkTimeout = setTimeout(checkContentHeight, 100);
      }
      
      // 初始检查 - 等待图片加载
      waitForImages(function() {
        checkContentHeight();
        // 再次延迟检查，确保所有样式和布局都已应用
        setTimeout(checkContentHeight, 200);
      });
      
      // 监听窗口大小改变
      window.addEventListener('resize', debouncedCheckContentHeight);
      
      // 监听内容变化（MutationObserver）
      if (typeof MutationObserver !== 'undefined') {
        const observer = new MutationObserver(function() {
          debouncedCheckContentHeight();
        });
        
        contentWrappers.forEach(function(contentWrapper) {
          observer.observe(contentWrapper, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['style', 'class']
          });
        });
      }
      
      // 点击事件 - 使用捕获阶段确保事件能够触发
      let lastToggleAt = 0;
      function handleShowMoreClick(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const now = Date.now();
        // 同时监听 mousedown + click 时，避免一次操作触发两次切换
        if (now - lastToggleAt < 200) return false;
        lastToggleAt = now;
        
        // 检查当前是否已展开
        const isExpanded = showMoreWrapper.classList.contains('t4s-expanded');
        
        // 切换所有 content-wrapper 的 expanded 状态
        contentWrappers.forEach(function(contentWrapper) {
          // 如果存在 Image(Child)，只切换左侧 wrapper（包含文本内容）的状态
          // 右侧 wrapper（包含 Image(Child)）不需要折叠，所以不切换
          if (hasImageChild) {
            const parentCol = contentWrapper.closest('.t4s-hero-content-col');
            if (parentCol && parentCol.classList.contains('t4s-hero-content-left')) {
              contentWrapper.classList.toggle('t4s-expanded');
            }
          } else {
            // 没有 Image(Child) 时，切换所有 wrapper 的状态
            contentWrapper.classList.toggle('t4s-expanded');
          }
        });
        showMoreWrapper.classList.toggle('t4s-expanded');
        
        // 更新 content-position 的顶部偏移（仅在移动端且配置了 expanded_top_offset_mb）
        const contentPosition = showMoreWrapper.closest('.t4s-content-position');
        if (contentPosition && window.innerWidth <= 767) {
          const expandedTopOffsetAttr = showMoreWrapper.getAttribute('data-expanded-top-offset-mb');
          // 如果配置了 expanded_top_offset_mb（包括设置为 0），则应用
          if (expandedTopOffsetAttr !== null && expandedTopOffsetAttr !== '') {
            if (!isExpanded) {
              // 展开时：添加类以应用展开后的顶部偏移
              contentPosition.classList.add('t4s-expanded-top-offset');
            } else {
              // 收起时：移除类，恢复原始顶部偏移
              contentPosition.classList.remove('t4s-expanded-top-offset');
            }
          }
        }
        
        // 更新 Image Positioned blocks 的样式（仅在移动端）
        if (window.innerWidth <= 767) {
          // 查找同一 section 内的所有 image positioned block containers
          const sectionElement = showMoreWrapper.closest('.t4s-section-inner') || showMoreWrapper.closest('.t4s_nt_se_' + sectionId);
          if (sectionElement) {
            const imagePositionedContainers = sectionElement.querySelectorAll('.t4s-image-positioned-block-container');
            imagePositionedContainers.forEach(function(container) {
              const positionMbExpanded = container.getAttribute('data-position-mb-expanded');
              const paddingTbMbExpanded = container.getAttribute('data-padding-tb-mb-expanded');
              
              if (!isExpanded) {
                // 展开时：应用展开后的样式
                if (positionMbExpanded) {
                  // 移除所有展开后的 position 类
                  container.classList.remove('t4s-pos-mb-expanded-left_top', 't4s-pos-mb-expanded-left_center', 't4s-pos-mb-expanded-left_bottom',
                    't4s-pos-mb-expanded-center_top', 't4s-pos-mb-expanded-center_center', 't4s-pos-mb-expanded-center_bottom',
                    't4s-pos-mb-expanded-right_top', 't4s-pos-mb-expanded-right_center', 't4s-pos-mb-expanded-right_bottom');
                  // 添加新的展开后的 position 类
                  container.classList.add('t4s-pos-mb-expanded-' + positionMbExpanded);
                }
                if (paddingTbMbExpanded !== null && paddingTbMbExpanded !== '') {
                  // 更新 CSS 变量
                  container.style.setProperty('--padding-tb-mb-expanded', paddingTbMbExpanded + 'px');
                }
                container.classList.add('t4s-expanded');
              } else {
                // 收起时：移除展开后的样式
                container.classList.remove('t4s-pos-mb-expanded-left_top', 't4s-pos-mb-expanded-left_center', 't4s-pos-mb-expanded-left_bottom',
                  't4s-pos-mb-expanded-center_top', 't4s-pos-mb-expanded-center_center', 't4s-pos-mb-expanded-center_bottom',
                  't4s-pos-mb-expanded-right_top', 't4s-pos-mb-expanded-right_center', 't4s-pos-mb-expanded-right_bottom');
                container.classList.remove('t4s-expanded');
                container.style.removeProperty('--padding-tb-mb-expanded');
              }
            });
          }
        }
        
        syncButtonLabel();
        
        // 修改 --aspect-ratio-cusmb CSS 变量
        // 只在移动端且 Section height (Mobile) 设置为 Custom height 时生效
        if (sectionElement && expandedHeight && window.innerWidth <= 767) {
          // 检查是否使用了 Custom height（通过检查 hero-inner 是否有对应的类）
          const heroImage = sectionElement.querySelector('.t4s-hero-image');
          if (heroImage && heroImage.classList.contains('t4s-hero-height-mb-t4s_ratio_cuspx')) {
            if (!isExpanded) {
              // 展开时：设置展开后的高度值
              sectionElement.style.setProperty('--aspect-ratio-cusmb', expandedHeight + 'px');
            } else {
              // 收起时：恢复为 Custom height value (Mobile) 的原始值
              if (originalHeight) {
                sectionElement.style.setProperty('--aspect-ratio-cusmb', originalHeight + 'px');
              } else {
                // 如果没有原始值，移除内联样式，恢复 CSS 变量或默认值
                sectionElement.style.removeProperty('--aspect-ratio-cusmb');
              }
            }
          }
        }
        
        return false;
      }
      
      // 使用捕获阶段监听，确保在父元素阻止之前捕获事件
      btn.addEventListener('click', handleShowMoreClick, true);
      btn.addEventListener('mousedown', handleShowMoreClick, true);
      
      // 确保按钮可点击
      btn.style.pointerEvents = 'auto';
      btn.style.cursor = 'pointer';
      btn.setAttribute('tabindex', '0');
      
      // 添加键盘支持
      btn.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleShowMoreClick(e);
        }
      });
    });
  }
  
  // 执行初始化函数
  function init() {
    processManualBoldNumbers();
    applyImageOrder();
    applyMobileBackgroundImage();
    initShowMore();
  }
  
  // 监听DOM变化，处理动态加载的内容
  function setupObserver() {
    if (typeof MutationObserver === 'undefined') return;
    
    if (!document.body) {
      // 如果body还不存在，等待DOMContentLoaded
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupObserver);
      } else {
        setTimeout(setupObserver, 100);
      }
      return;
    }
    
    const observer = new MutationObserver(function(mutations) {
      let shouldReinit = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              if (node.classList && (
                node.classList.contains('t4s-hero-image') ||
                (node.querySelector && node.querySelector('.t4s-hero-image'))
              )) {
                shouldReinit = true;
              }
            }
          });
        }
      });
      if (shouldReinit) {
        setTimeout(init, 50);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // 使用多种方式确保执行
  function runInit() {
    // 如果DOM已经加载完成，立即执行
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        init();
        setupObserver();
      });
    } else {
      init();
      setupObserver();
    }
  }
  
  // 页面加载完成后执行
  runInit();
  
  // 确保在window.load时也执行一次
  window.addEventListener('load', function() {
    setTimeout(init, 100);
  });
  
  // 窗口大小改变时重新执行
  window.addEventListener('resize', function() {
    applyImageOrder();
    applyMobileBackgroundImage();
  });
})();

